module.exports = __webpack_public_path__ + "static/media/task1Planet2.ff69adb1.png";